/**
 * WPath — polskie tłumaczenia.
 *
 * Source-of-truth shape — `en.ts` / `de.ts` typowane przez `WPathTranslations`.
 * Stringi UI chrome (aria-label). Nazwy w breadcrumb (Home, nazwy katalogów,
 * artykuły) pochodzą z `AdminContext.pageBreadcrumb` — server-side built
 * z lokalizowanych danych backendu.
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  ariaLabel: "Ścieżka nawigacji",
} as const;

export type WPathTranslations = DeepString<typeof pl>;
